<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="文章标题">
                <a-input v-model="queryParam.title" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="文章分类">
                <a-select v-model="queryParam.classId" placeholder="请选择" style="width: 100%" allow-clear>
                  <a-select-option v-for="item in classList" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="文章状态">
                <a-select v-model="queryParam.status" placeholder="请选择" style="width: 100%" allow-clear>
                  <a-select-option :value="0">草稿</a-select-option>
                  <a-select-option :value="1">待审核</a-select-option>
                  <a-select-option :value="2">已发布</a-select-option>
                  <a-select-option :value="-1">回收站</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['article:type:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['article:type:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <create-form ref="createForm" @ok="getList" />
      <detail-drawer ref="detailDrawer" />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        class="center-table"
      >
        <span slot="recommend" slot-scope="text, record">
          {{ record.recommend === 1 ? '是' : '否' }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="getStatusColor(record.status)">
            {{ getStatusText(record.status) }}
          </a-tag>
        </span>
        <span slot="publicTime" slot-scope="text, record">
          {{ record.publicTime || '--' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ record.createTime || '--' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['article:type:edit']"
            v-if="record.status !== 2"
            >修改</a
          >
          <a-divider
            type="vertical"
            v-hasPermi="[
              'article:article:release',
              'article:article:unrelease',
              'article:type:query',
              'article:type:remove',
            ]"
            v-if="record.status !== 2"
          />
          <a-dropdown
            v-hasPermi="[
              'article:article:release',
              'article:article:unrelease',
              'article:type:query',
              'article:type:remove',
            ]"
          >
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['article:article:release']" v-if="record.status === 0 || record.status === 1">
                <a @click="handleRelease(record)" v-hasPermi="['article:article:release']">发布</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['article:article:unrelease']" v-if="record.status === 2">
                <a @click="handleUnrelease(record)" v-hasPermi="['article:article:unrelease']">下架</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['article:type:remove']" v-if="record.status !== 2">
                <a @click="handleDelete(record)" v-hasPermi="['article:type:remove']">删除</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['article:type:query']">
                <a @click="$refs.detailDrawer.show(record)" v-hasPermi="['article:type:query']">详情</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { pageArticle, delArticle, releaseArticle, unreleaseArticle } from '@/api/tutorial/article'
import { listArticleType } from '@/api/tutorial/articleType'
import CreateForm from './modules/CreateForm'
import DetailDrawer from './modules/DetailDrawer'
import moment from 'moment'

export default {
  name: 'TutorialArticle',
  components: {
    CreateForm,
    DetailDrawer,
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
        shortTitle: undefined,
        classId: undefined,
        recommend: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      },
      total: 0,
      value: [],
      loading: false,
      tableSize: 'default',
      tableBordered: true,
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      classList: [],
      columns: [
        {
          title: '文章标题',
          dataIndex: 'title',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '文章短标题',
          dataIndex: 'shortTitle',
          align: 'center',
        },
        {
          title: '文章分类',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '文章作者',
          dataIndex: 'author',
          align: 'center',
        },
        {
          title: '推荐',
          dataIndex: 'recommend',
          scopedSlots: { customRender: 'recommend' },
          align: 'center',
        },
        {
          title: '文章状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        // {
        //   title: '文章点击量',
        //   dataIndex: 'click',
        //   align: 'center',
        // },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          width: 160,
        },
      ],
    }
  },
  methods: {
    getList() {
      this.loading = true
      pageArticle(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    getClassList() {
      listArticleType().then((res) => {
        this.classList = res.data || []
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
        shortTitle: undefined,
        classId: undefined,
        recommend: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    onChangeTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      var that = this
      let ids = []
      if (row && row.id) {
        if (row.status === 2) {
          this.$message.warning('已发布的文章不能删除', 3)
          return
        }
        ids = [{ id: row.id }]
      } else {
        if (!this.ids || this.ids.length === 0) {
          this.$message.warning('请选择要删除的数据', 3)
          return
        }
        const publishedIds = this.selectedRows.filter((item) => item.status === 2)
        if (publishedIds.length > 0) {
          this.$message.warning('选中的数据中包含已发布的文章，已发布的文章不能删除', 3)
          return
        }
        this.ids.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: row && row.id ? '是否确认删除此数据?' : `是否确认删除选中的 ${ids.length} 条数据?`,
        onOk() {
          return delArticle(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    getStatusText(status) {
      const statusMap = {
        0: '草稿',
        1: '待审核',
        2: '已发布',
        '-1': '回收站',
      }
      return statusMap[status] || '--'
    },
    getStatusColor(status) {
      const colorMap = {
        0: 'blue',
        1: 'orange',
        2: 'green',
        '-1': 'red',
      }
      return colorMap[status] || 'default'
    },
    handleRelease(row) {
      var that = this
      this.$confirm({
        title: '是否确认发布此文章?',
        onOk() {
          return releaseArticle({ id: row.id }).then(() => {
            that.getList()
            that.$message.success('发布成功', 3)
          })
        },
        onCancel() {},
      })
    },
    handleUnrelease(row) {
      var that = this
      this.$confirm({
        title: '是否确认下架此文章?',
        onOk() {
          return unreleaseArticle({ id: row.id }).then(() => {
            that.getList()
            that.$message.success('下架成功', 3)
          })
        },
        onCancel() {},
      })
    },
    hasMoreActions(record) {
      return record.status === 0 || record.status === 1 || record.status === -1 || record.status === 2
    },
  },
  created() {
    this.getClassList()
    this.getList()
  },
}
</script>
<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper .ant-form-item {
  margin-bottom: 16px;
}

.center-table .ant-table-thead > tr > th {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-tbody > tr > td {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-thead > tr > th,
.center-table .ant-table-tbody > tr > td {
  vertical-align: middle;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: center;
}

.center-table {
  width: 100%;
}

.center-table .ant-table-container {
  width: 100%;
}

.center-table .ant-table-content {
  text-align: center;
}
</style>
